"use strict";

exports.__esModule = true;
exports.DashboardList = DashboardList;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _System = require("../../../System");
var _Theme = require("../../Theme");
var _DashboardThumbnail = require("../DashboardThumbnail");
var _Core = require("../../Core");
var _excluded = ["onItemClick", "items", "selectedIds"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
// The gallery from the next-gen design: each dashboard is a white shadow
// card with its preview in a soft well and a bold name that wraps to two
// lines and then truncates, so long names stay inside the card.
var DashboardListContainer = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListmodern__DashboardListContainer",
  componentId: "sc-x8rr1d-0"
})(["display:grid;height:100%;padding:20px 24px;gap:16px;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));grid-auto-rows:max-content;align-content:start;"]);
var DashboardListItem = (0, _styledComponents["default"])(_reactRouterDom.Link).withConfig({
  displayName: "DashboardListmodern__DashboardListItem",
  componentId: "sc-x8rr1d-1"
})(["display:flex;flex-direction:column;gap:10px;box-sizing:border-box;padding:12px;color:#1b2227;background:#ffffff;border-radius:12px;box-shadow:", ";transition:box-shadow 120ms ease,transform 120ms ease;& svg{color:#000;}&:hover,&:focus-visible{text-decoration:none;color:#1b2227;box-shadow:", ";transform:translateY(-1px);}&[aria-selected=\"true\"]{box-shadow:", ",0 0 0 2px #e8621e;}"], (0, _Theme.val)("CardShadow"), (0, _Theme.val)("CardShadowRaised"), (0, _Theme.val)("CardShadow"));
var DashboardListItemPreview = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListmodern__DashboardListItemPreview",
  componentId: "sc-x8rr1d-2"
})(["display:flex;justify-content:center;align-items:center;padding:8px;border-radius:8px;background:#f8fafb;"]);
var DashboardListItemLabel = _styledComponents["default"].div.withConfig({
  displayName: "DashboardListmodern__DashboardListItemLabel",
  componentId: "sc-x8rr1d-3"
})(["display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;overflow-wrap:anywhere;min-height:2.5em;margin:0 2px;font-family:", ";font-size:14px;font-weight:700;letter-spacing:-0.01em;line-height:1.25;text-align:center;color:#1b2227;"], (0, _Theme.val)("FontFamilyHeading"));
function renderDashboard(item, selectedIds, onItemClick) {
  return /*#__PURE__*/_react["default"].createElement(_Core.ErrorBoundary, null, /*#__PURE__*/_react["default"].createElement(DashboardListItem, {
    key: item.id,
    "data-testid": "DashboardListItem",
    to: (0, _System.getScreenURL)("Dashboard", item),
    "aria-selected": selectedIds.includes(item.id),
    onClick: typeof onItemClick !== "function" ? undefined : function (e) {
      e.preventDefault();
      onItemClick(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(DashboardListItemPreview, null, /*#__PURE__*/_react["default"].createElement(_DashboardThumbnail.DashboardThumbnail, {
    width: 140,
    height: 105,
    dashboard: item
  })), /*#__PURE__*/_react["default"].createElement(DashboardListItemLabel, {
    "data-testid": "DashboardListItem.label",
    title: item.name
  }, item.name)));
}

/**
 * Shows a list of dashboards.
 */
function DashboardList(_ref) {
  var onItemClick = _ref.onItemClick,
    items = _ref.items,
    _ref$selectedIds = _ref.selectedIds,
    selectedIds = _ref$selectedIds === void 0 ? [] : _ref$selectedIds,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(DashboardListContainer, _extends({
    "data-testid": "DashboardList"
  }, extra), items.map(function (item) {
    return renderDashboard(item, selectedIds, onItemClick);
  }));
}